import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useState, type FormEvent } from 'react';
import { useNavigate } from 'react-router-dom';

import { requestOtp, verifyOtp } from '@/lib/api';

export function SignInPage() {
  const [email, setEmail] = useState('');
  const [token, setToken] = useState('');
  const [codeRequested, setCodeRequested] = useState(false);
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const request = useMutation({
    mutationFn: requestOtp,
    onSuccess: () => setCodeRequested(true),
  });
  const verify = useMutation({
    mutationFn: () => verifyOtp(email, token),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ['analytics-session'] });
      navigate('/', { replace: true });
    },
  });

  function submit(event: FormEvent) {
    event.preventDefault();
    if (codeRequested) verify.mutate(); else request.mutate(email);
  }

  const error = request.error ?? verify.error;
  return <main className="auth-page">
    <img src="/images/sia-logo.png" alt="Sia" className="auth-logo" />
    <section className="auth-panel">
      <p className="eyebrow">Analytics admin</p>
      <h1>{codeRequested ? 'Enter your sign-in code' : 'Welcome back'}</h1>
      <p className="auth-copy">{codeRequested
        ? `If ${email} is provisioned, a six-digit code is on its way.`
        : 'Use a provisioned analytics administrator account. New accounts cannot be created here.'}</p>
      <form onSubmit={submit}>
        <label>Email address<input type="email" autoComplete="email" required disabled={codeRequested} value={email} onChange={(event) => setEmail(event.target.value)} /></label>
        {codeRequested ? <label>Six-digit code<input type="text" inputMode="numeric" autoComplete="one-time-code" pattern="[0-9]{6}" maxLength={6} required autoFocus value={token} onChange={(event) => setToken(event.target.value.replace(/\D/g, ''))} /></label> : null}
        {error ? <p className="form-error" role="alert">{error.message}</p> : null}
        <button className="button button--primary" disabled={request.isPending || verify.isPending}>
          {request.isPending || verify.isPending ? 'Please wait…' : codeRequested ? 'Verify code' : 'Email me a code'}
        </button>
        {codeRequested ? <button type="button" className="text-button" onClick={() => { setCodeRequested(false); setToken(''); }}>Use a different email</button> : null}
      </form>
    </section>
  </main>;
}
